import { PricingPlanConfig } from '~/landingV4/types/pricing.types'

export const DAYS_PER_YEAR = 365
export const DAYS_PER_MONTH = 30

export const PRICING_PLANS: PricingPlanConfig[] = [
  { type: 'yearly', titleKey: 'v4.pricing.yearly', isPopular: true, hasSaveBadge: true },
  { type: 'monthly', titleKey: 'v4.pricing.monthly', isPopular: false, hasSaveBadge: true },
]
